<template>
	<div class="body">
		<div class="body-container" v-if="gdpJobData"  v-loading="loading" element-loading-text="加载中..." >

			<div class="title-ctr">{{title}}</div>

			<div class="step-ctr">
				<div class="step-route" @click="clickRule(ruleData)">{{ruleData.title}}</div>
			</div>

			<div class="title-ch">{{gdpJobData.title}}</div>

			<el-table :data="gdpJobData.list" border stripe>
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="一产GDP占比" align="center" prop="first">
					<template v-slot="{ row }">
						<label style="color: blue;">{{row.first.rate1}}</label>
					</template>
				</el-table-column>
				<el-table-column label="一产就业占比" align="center" prop="second">
					<template v-slot="{ row }">
						<label style="color: blue;">{{row.first.rate2}}</label>
					</template>
				</el-table-column>
				<el-table-column label="一产偏离度" align="center" prop="third">
					<template v-slot="{ row }">
						<label style="color: blue;">{{row.first.dvn}}</label>
					</template>
				</el-table-column>
				<el-table-column label="一产权重" align="center" prop="all">
					<template v-slot="{ row }">
						<label style="color: blue;">{{row.first.weight}}</label>
					</template>
				</el-table-column>

				<el-table-column label="二产GDP占比" align="center" prop="first">
					<template v-slot="{ row }">
						<label style="color: green;">{{row.first.rate1}}</label>
					</template>
				</el-table-column>
				<el-table-column label="二产就业占比" align="center" prop="second">
					<template v-slot="{ row }">
						<label style="color: green;">{{row.first.rate2}}</label>
					</template>
				</el-table-column>
				<el-table-column label="二产偏离度" align="center" prop="third">
					<template v-slot="{ row }">
						<label style="color: green;">{{row.first.dvn}}</label>
					</template>
				</el-table-column>
				<el-table-column label="二产权重" align="center" prop="all">
					<template v-slot="{ row }">
						<label style="color: green;">{{row.first.weight}}</label>
					</template>
				</el-table-column>

				<el-table-column label="三产GDP占比" align="center" prop="first">
					<template v-slot="{ row }">
						<label style="color: black;">{{row.first.rate1}}</label>
					</template>
				</el-table-column>
				<el-table-column label="三产就业占比" align="center" prop="second">
					<template v-slot="{ row }">
						<label style="color: black;">{{row.first.rate2}}</label>
					</template>
				</el-table-column>
				<el-table-column label="三产偏离度" align="center" prop="third">
					<template v-slot="{ row }">
						<label style="color: black;">{{row.first.dvn}}</label>
					</template>
				</el-table-column>
				<el-table-column label="三产权重" align="center" prop="all">
					<template v-slot="{ row }">
						<label style="color: black;">{{row.first.weight}}</label>
					</template>
				</el-table-column>

				<el-table-column label="综合偏离度" align="center" prop="third">
					<template v-slot="{ row }">
						<label style="color: #0962BE;">{{row.all}}</label>
					</template>
				</el-table-column>
			</el-table>

			<div class="title-ch">{{gdpEnrollData.title}}</div>

			<el-table :data="gdpEnrollData.list" border stripe>
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="一产GDP占比" align="center" prop="first">
					<template v-slot="{ row }">
						<label style="color: blue;">{{row.first.rate1}}</label>
					</template>
				</el-table-column>
				<el-table-column label="一产就业占比" align="center" prop="second">
					<template v-slot="{ row }">
						<label style="color: blue;">{{row.first.rate2}}</label>
					</template>
				</el-table-column>
				<el-table-column label="一产偏离度" align="center" prop="third">
					<template v-slot="{ row }">
						<label style="color: blue;">{{row.first.dvn}}</label>
					</template>
				</el-table-column>
				<el-table-column label="一产权重" align="center" prop="all">
					<template v-slot="{ row }">
						<label style="color: blue;">{{row.first.weight}}</label>
					</template>
				</el-table-column>

				<el-table-column label="二产GDP占比" align="center" prop="first">
					<template v-slot="{ row }">
						<label style="color: green;">{{row.second.rate1}}</label>
					</template>
				</el-table-column>
				<el-table-column label="二产专业占比" align="center" prop="second">
					<template v-slot="{ row }">
						<label style="color: green;">{{row.second.rate2}}</label>
					</template>
				</el-table-column>
				<el-table-column label="二产偏离度" align="center" prop="third">
					<template v-slot="{ row }">
						<label style="color: green;">{{row.second.dvn}}</label>
					</template>
				</el-table-column>
				<el-table-column label="二产权重" align="center" prop="all">
					<template v-slot="{ row }">
						<label style="color: green;">{{row.second.weight}}</label>
					</template>
				</el-table-column>

				<el-table-column label="三产GDP占比" align="center" prop="first">
					<template v-slot="{ row }">
						<label style="color: black;">{{row.third.rate1}}</label>
					</template>
				</el-table-column>
				<el-table-column label="三产专业占比" align="center" prop="second">
					<template v-slot="{ row }">
						<label style="color: black;">{{row.third.rate2}}</label>
					</template>
				</el-table-column>
				<el-table-column label="三产偏离度" align="center" prop="third">
					<template v-slot="{ row }">
						<label style="color: black;">{{row.third.dvn}}</label>
					</template>
				</el-table-column>
				<el-table-column label="三产权重" align="center" prop="all">
					<template v-slot="{ row }">
						<label style="color: black;">{{row.third.weight}}</label>
					</template>
				</el-table-column>

				<el-table-column label="综合偏离度" align="center" prop="third">
					<template v-slot="{ row }">
						<label style="color: #0962BE;">{{row.all}}</label>
					</template>
				</el-table-column>
			</el-table>

			<div class="title-ch">{{jobEnrollData.title}}</div>

			<el-table :data="jobEnrollData.list" border stripe>
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="一产就业占比" align="center" prop="first">
					<template v-slot="{ row }">
						<label style="color: blue;">{{row.first.rate1}}</label>
					</template>
				</el-table-column>
				<el-table-column label="一产专业占比" align="center" prop="second">
					<template v-slot="{ row }">
						<label style="color: blue;">{{row.first.rate2}}</label>
					</template>
				</el-table-column>
				<el-table-column label="一产偏离度" align="center" prop="third">
					<template v-slot="{ row }">
						<label style="color: blue;">{{row.first.dvn}}</label>
					</template>
				</el-table-column>
				<el-table-column label="一产权重" align="center" prop="all">
					<template v-slot="{ row }">
						<label style="color: blue;">{{row.first.weight}}</label>
					</template>
				</el-table-column>

				<el-table-column label="二产就业占比" align="center" prop="second">
					<template v-slot="{ row }">
						<label style="color: green;">{{row.second.rate1}}</label>
					</template>
				</el-table-column>
				<el-table-column label="二产专业占比" align="center" prop="second">
					<template v-slot="{ row }">
						<label style="color: green;">{{row.second.rate2}}</label>
					</template>
				</el-table-column>
				<el-table-column label="二产偏离度" align="center" prop="third">
					<template v-slot="{ row }">
						<label style="color: green;">{{row.second.dvn}}</label>
					</template>
				</el-table-column>
				<el-table-column label="二产权重" align="center" prop="all">
					<template v-slot="{ row }">
						<label style="color: green;">{{row.second.weight}}</label>
					</template>
				</el-table-column>

				<el-table-column label="三产就业占比" align="center" prop="third">
					<template v-slot="{ row }">
						<label style="color: black;">{{row.third.rate1}}</label>
					</template>
				</el-table-column>
				<el-table-column label="三产专业占比" align="center" prop="second">
					<template v-slot="{ row }">
						<label style="color: black;">{{row.third.rate2}}</label>
					</template>
				</el-table-column>
				<el-table-column label="三产偏离度" align="center" prop="third">
					<template v-slot="{ row }">
						<label style="color: black;">{{row.third.dvn}}</label>
					</template>
				</el-table-column>
				<el-table-column label="三产权重" align="center" prop="all">
					<template v-slot="{ row }">
						<label style="color: black;">{{row.third.weight}}</label>
					</template>
				</el-table-column>

				<el-table-column label="综合偏离度" align="center" prop="third">
					<template v-slot="{ row }">
						<label style="color: #0962BE;">{{row.all}}</label>
					</template>
				</el-table-column>
			</el-table>


			<div class="title-ch">{{allData.title}}</div>

			<el-table :data="allData.list" border stripe>
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="产业-就业匹配" align="center" prop="gdp_job_match" />
				<el-table-column label="产业-专业匹配" align="center" prop="gdp_enroll_match" />
				<el-table-column label="就业-专业匹配" align="center" prop="job_enroll_match" />
				<el-table-column label="耦合度" align="center" prop="coupling" />
				<el-table-column label="协调指数" align="center" prop="coordinate" />
				<el-table-column label="耦合协调度" align="center" prop="coupling_coordinate" />
			</el-table>
		</div>

		<div class="action-ctr">
			<div class="tips" v-if="tips">{{tips}}</div>
			<el-button type="primary" icon="el-icon-download" size='medium' @click="clickNext()"
				class="next-btn">下载</el-button>
		</div>

		<el-dialog title="原理介绍" :visible.sync="showIntroDialog" append-to-body v-if="showIntroDialog" align="center">

			<div class="rich-ctr">
				<div class="rich-value" v-html="introDialog.value"></div>
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseIntroDialog()">确 定</el-button>
			</div>
		</el-dialog>

		<PayDialog v-if="showPay" :visible.sync="showPay" :pay-dialog-data="payDialogData" @success="onPaid" @change-pay="onChangePay"
			@close="onClose" />

	</div>
</template>

<script>
	import PayDialog from '@/components/PayDialog/index.vue'
	import {
		getDvnResult,
		exportDeviation,
		createDownloadDeviationOrder
	} from "@/api/service"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		components: {
			PayDialog
		},
		data() {
			return {
				params: {
					page: 1,
					pageSize: 20
				},
				showIntroDialog: false,
				introDialog: null,
				gdpJobData: null,
				gdpEnrollData: null,
				jobEnrollData: null,
				allData: null,
				ruleData: null,
				variableType: {
					File: 2,
					Rich: 3
				},
				title: '',
				tips: '',
				showPay: false,
				payDialogData: null,
				loading: true
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.params['id'] = this.$route.query.id;
				this.requestData();
			},

			buildParams() {
				return this.params;
			},

			requestData() {
				getDvnResult(this.buildParams()).then(res => {
					let realData = res.data;
					this.title = realData.title;
					this.gdpJobData = realData.gdpJobData;
					this.gdpEnrollData = realData.gdpEnrollData;
					this.jobEnrollData = realData.jobEnrollData;
					this.allData = realData.allData;
					this.ruleData = realData.ruleData;
					this.tips = realData.tips;
					this.loading = false;
				});
			},

			clickNext() {
				this.loading = true;
				exportDeviation(this.params).then(res => {
					let realData = res.data;
					this.loading = false;
					if (realData.payDialog) {
						this.toPay(realData.payDialog)
					} else if (realData.url) {
						window.open(realData.url, '_blank')
					}
				})
			},

			clickRule(route) {
				if (route.type == this.variableType.File) {
					let path = route.path;
					window.open(path, '_blank')
				} else if (route.type == this.variableType.Rich) {
					this.showIntroDialog = true;
					this.introDialog = route;
				}
			},

			clickCloseIntroDialog() {
				this.showIntroDialog = false;
			},

			toPay(payDialogData) {
				this.showPay = true
				this.payDialogData = payDialogData;
			},

			onChangePay(item) {
				console.log('onChangePay item', item)
				let params = this.buildParams();
				params['pay_id'] = item['id'];
				createDownloadDeviationOrder(params).then(res => {
					console.log(res)
					let realData = res.data;
					let url = realData.url;
					if (url != undefined && url != '') {
						window.open(url);
					}
				})	
			},

			onPaid(res) {
				// this.$message.success('支付成功')
				console.log('onPaid res', res)
				this.showPay = false
				let replaceUrl = res.replace_url;
				this.$router.replace(replaceUrl);
			},

			onClose() {
				console.log('弹窗关闭')
			},
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "dvn_result.scss";
</style>